// @ts-check
import Typography from "@mui/material/Typography";
import MyText from "../../controls/MyText";
import { useEffect, useState } from "react";
import MyAlert from "../../controls/MyAlert";
import {
  enumLocalStorageArgs, enumPage,
  enumPagination,
  enumRoutes,
  enumSharedMsgs
} from "../../helpers/common.constants";
import Button from "@mui/material/Button";
import {
  Grid, Table,
  TableBody,
  TableCell,
  TableContainer, TableFooter, TableHead,
  TableRow
} from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import Link from "@mui/material/Link";
import { MessageHelper } from "../../helpers/MessageHelper";
import LocalStorageHelper from "../../helpers/LocalStorageHelper";
import PayrollActions from "../../actions/PayrollActions";
import CurrencyHelper from "../../helpers/CurrencyHelper";
import moment from "moment";
import MyDialogYesNo from "../../controls/MyDialogYesNo";
import DocumentActions from "../../actions/DocumentActions";

const RecordDefault = {
  OfficeID: 1445,
  CountryIDs: "",
  Name: "",
  PhaseIDs: "",
  ActiveFL: "1",
  TypeOfContractID: 0,
  ExpirationContractDays: 0,

  //Pagination
  PageIndex: 0,
  PageSize: enumPagination.PageSizeLow,
  TotalRecords: 0,
  TotalPages: 0,
  Year: 2025,
  Month: 1,
  Lock: false,
  OfficeName: "",
  VerifierName: "", //Verifier
  PayrollSummaryID: 0,
  Note: "", //Verifier
  StaffApprovers: "",
  PhaseTitle: ""
};

const styles = {
  TDSmall: { mt: 0, mb: 0, pt: 0, pb: 0 },
};

export default function PayrollPreview() {
  const [Record, setRecord] = useState(RecordDefault);
  const [UploadedFileData, setUploadedFileData] = useState(null);

  const [MessageData, setMessageData] = useState({});
  const [Records, setRecords] = useState([]);
  const [RootRecord, setRootRecord] = useState(null);
  const [RecordsSum, setRecordsSum] = useState([]);
  const [IsInitDone, setIsInitDone] = useState(false);
  const [IsPaginationChange, setPaginationChange] = useState(false);
  const [IsDoSearch, setIsDoSearch] = useState(false);
  const [IsSubmitted, setIsSubmitted] = useState(false);
  const [IsVerified, setIsVerified] = useState(false);
  const [IsModalOpenSubmit, setIsModalOpenSubmit] = useState(false);
  const [IsModalOpen, setIsModalOpen] = useState(false);
  const [IsModalOpenVerify, setIsModalOpenVerify] = useState(false);
  const [ModalMessage, setModalMessage] = useState("");
  const [LookupData, setLookupData] = useState([]);
  const [OfficeData, setOfficeData] = useState([]);
  const [CurrencyExcRates, setCurrencyExcRates] = useState([]);
  const { OfficeID, Year, Month, showMsg } = useParams(); //Timesheet_Payroll_Verify: "/Timesheet/payroll_verify/OfficeID/Year/Month", //OfficeID/Year/month
  const [IsLocked, setIsLocked] = useState(false);

  //Za Refreshiranje na strana mu treba;
  const location = useLocation();

  //za poraki pri loadiranje na strana
  let msgHelper = new MessageHelper();

  //****************************************** */
  //HOOKS SECTION HERE
  //****************************************** */

  //1 --> Ke se povika ovoj HOOK samo dokolku se SMENI url-ot poradi toa na new dodavame Ticks() za da forcirame refresh na strana na sekoj click
  useEffect(() => {
    initData();
  }, [location.pathname + "/" + location.search]);

  //2 --> Od koga e sredena InitData() povikaj Search  (https://stackoverflow.com/questions/54069253/the-usestate-set-method-is-not-reflecting-a-change-immediately)
  useEffect(() => {
    if (IsInitDone) {
      searchData();
    }
  }, [IsInitDone]);

  // //3 --> Pagination Change
  useEffect(() => {
    if (IsPaginationChange) {
      searchData();
    }
  }, [IsPaginationChange]);

  //4 --> Search Click
  useEffect(() => {
    if (IsDoSearch) {
      searchData();
    }
  }, [IsDoSearch]);

  //****************************************** */
  //METHOD  SECTION HERE
  //****************************************** */
  const initData = () => {
    async function fetchData() {
      //Clean all statesLock      setIsInitDone(false);

      RecordDefault.OfficeID = parseInt(OfficeID); //od Request
      RecordDefault.Month = parseInt(Month); //od Request
      RecordDefault.Year = parseInt(Year); //od Request
      setRecord(RecordDefault);


      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let responses = await new PayrollActions().InitAsync(RecordDefault); // await LookupActions.InitAsync();
      if (!responses.error) {
        let lookupData = responses[0].data;
        let officeData = responses[1].data;

        setLookupData(lookupData);

        setOfficeData(officeData);

        //setYearsData(yearsData);
        setIsInitDone(true);

        //Load Finished
        result = msgHelper.setPhase(enumPage.LoadSuccess);
        setMessageData(result);
      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name + ":" + value);
    setRecord((prevState) => ({ ...prevState, [name]: value }));
  };

  const searchData = () => {
    searchDataAsync();
  };

  async function searchDataAsync() {
    //Load Start
    setRecords([]);
    let result = msgHelper.setPhase(enumPage.LoadStart);
    setMessageData(result);

    let responses = await new PayrollActions().SearchAsync(Record);
    if (!responses.error) {
      const records = responses[0].data;

      //For Pagination purposes
      const pageIndex = responses[0].headers["content-pageindex"];
      const totalRecords = responses[0].headers["content-totalrecords"];
      const totalPages = responses[0].headers["content-totalpages"];

      setRecord((a) => ({
        ...a,
        ["PageIndex"]: pageIndex,
        ["TotalRecords"]: totalRecords,
        ["TotalPages"]: totalPages,
      }));
      setPaginationChange(false); //za da se pali na sleden page
      setIsDoSearch(false); //za da se pali na Search Click

      setRecords(records);

      //napravi sum records
      makeSumRecord(records);

      if (records.length > 0) {
        setRootRecord(records[0]);
      }


      if (records.length === 0) {
        result = msgHelper.setPhase(
          enumPage.LoadSuccessWithWarningMsg,
          null,
          "No records found"
        );
        setMessageData(result);
        return;
      }

      //odreduva dali ke zakluci cel period i ke napise poraka
      let firstRecordForLockUnlock = records[0];
      let IsSubmitted = firstRecordForLockUnlock.prIsVerified;
      let isVerified = firstRecordForLockUnlock.prIsVerified2;

      let verifierName = firstRecordForLockUnlock.prVerifierFullName;
      let officeName = firstRecordForLockUnlock.prEmployeeOffice;
      let PayrollSummaryID = firstRecordForLockUnlock.prPayrollSummaryID;
      let staffApprovers = firstRecordForLockUnlock.prsStaffApprovers;
      let phaseTitle = firstRecordForLockUnlock.prsPhaseTitle;

      setRecord((a) => ({
        ...a,
        ["VerifierName"]: verifierName,
        ["OfficeName"]: officeName,
        ["PayrollSummaryID"]: PayrollSummaryID,
        ["StaffApprovers"]: staffApprovers,
        ["PhaseTitle"]: phaseTitle
      }));

      setIsSubmitted(IsSubmitted);
      setIsVerified(isVerified);

      setMessageData(result);


      if (showMsg === "1") {
        result = msgHelper.setPhase(enumPage.LoadSuccessWithWarningMsg, null, "Payroll has been sent for verification");
        setMessageData(result);
        return;
      }
      else if (showMsg === "2") {
        result = msgHelper.setPhase(enumPage.LoadSuccessWithWarningMsg, null, "Payroll has been already verified");
        setMessageData(result);
        return;
      }
      else if (showMsg === "3") {
        result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Payroll has been disapproved");
        setMessageData(result);
        return;
      }
      else if (showMsg === "4") {
        result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Payroll has been verified");
        setMessageData(result);
        return;
      }

      //Load Finished
      result = msgHelper.setPhase(enumPage.LoadSuccess);
      setMessageData(result);
    } else {
      //Load with Error
      setIsDoSearch(false); //za da se pali na Search Click
      result = msgHelper.setPhase(enumPage.ErrorServer, responses);
      setMessageData(result);
    }
  }


  const makeSumRecord = (currentRecords) => {
    let newSumRecord = {};

    newSumRecord.prSparkAmount = currentRecords.reduce(
      (sum, row) => (sum = sum + parseFloat(row.prSparkAmount)),
      0
    );


    setRecordsSum(newSumRecord);
  };

  const downloadFile = (fileName, fileId) => {
    async function fetchData() {

      let result = msgHelper.setPhase(enumPage.LoadStartWithAwaitMsg, null, "Please wait, downloading file, it could take a while...");
      setMessageData(result);

      let payload = "/" + fileId;
      let response = await new DocumentActions().DownloadFileAsync(payload);

      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      result = msgHelper.setPhase(enumPage.LoadSuccess);
      setMessageData(result);
    }
    fetchData();
  };



  return (
    <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="left">
      <MyAlert {...MessageData} />

      <TableContainer
        sx={{ display: { xs: "block", sm: "block", md: "block" } }}
      >
        <Table
          sx={{ minWidth: 650, border: "1" }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell colSpan={8}>
                <Typography variant="h3" align="center">
                  Payroll preview for {moment(new Date(Year, Month - 1, 1)).format("MMMM yyyy")} for office {Record.OfficeName} Step: {Record.PhaseTitle}
                </Typography>
                <Typography variant="h4" align="center">
                  {Record.StaffApprovers}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" align="center">
                  Employee Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="center">
                  Email
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="center">
                  Office Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="center">
                  Local Amount
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="center">
                  Local Currency
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="center">
                  Exch.Rate
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" align="center">
                  EUR Amount
                </Typography>
              </TableCell>
            </TableRow>

          </TableHead>
          <TableBody>
            {Records.map((row, index) => (
              <TableRow
                style={{ backgroundColor: row.prTypeID === 1 ? 'white' : 'lightgray' }}
                key={row.eyEmployeeID}
                sx={[styles.TDSmall]}
              >
                <TableCell sx={{ mt: 0, mb: 0, pt: 0, pb: 0, width: "25%" }}>
                  {index + 1}.
                  <Link
                    href={enumRoutes.Employee_Edit.replace(
                      ":EmployeeID",
                      row.prEmployeeID
                    )}
                    underline="none"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {row.prEmployeeFullName}
                    <br />
                  </Link>
                  <i>
                    Contract period:{moment(row.prContractStart).format("DD/MM/YYYY")} -{" "}
                    {moment(row.prContractEnd).format("DD/MM/YYYY")}
                  </i>
                </TableCell>
                <TableCell sx={{ mt: 0, mb: 0, pt: 0, pb: 0, width: "20%" }}>
                  {row.prEmployeeEmail}
                  <br />
                  <i>
                    Contract amount: {row.prContractAmount} {row.prContractCurrencyName}
                  </i>
                </TableCell>

                <TableCell sx={[styles.TDSmall]}>
                  {row.prEmployeeOffice}
                  <br />
                  <i>FTE: {row.prContractFTE}</i>
                </TableCell>


                <TableCell align="right" sx={[styles.TDSmall]}>
                  {new CurrencyHelper().ToMoneyFormatDigits(row.prLocalAmount, 2)}
                </TableCell>

                <TableCell align="right" sx={[styles.TDSmall]}>
                  {row.prLocalCurrencyName}
                </TableCell>


                <TableCell sx={[styles.TDSmall]} align="right">
                  {new CurrencyHelper().ToMoneyFormatDigits(row.prExchangeRate, 2)}
                </TableCell>

                <TableCell sx={[styles.TDSmall]} align="right">
                  {new CurrencyHelper().ToMoneyFormatDigits(row.prSparkAmount, 2)}
                </TableCell>
              </TableRow>

            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={6}>
                <Typography variant="h6" align="right">
                  Total
                </Typography>
              </TableCell>
              <TableCell align="right">
                <b>{new CurrencyHelper().ToMoneyFormatDigits(
                  RecordsSum.prSparkAmount,
                  2
                )}</b>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Grid container align="left" sx={{ borderBottom: 1, borderColor: 'grey.500', pb: 1 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mr: 0, mt: 1 }}>
            <b>Notes</b>
          </Typography>
        </Grid>
      </Grid>

      {RootRecord != null && RootRecord.prsNotes &&
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ ml: 0, mr: 0, mt: 1 }}>
              <div dangerouslySetInnerHTML={{ __html: RootRecord.prsNotes }} />
            </Typography>
          </Grid>
        </Grid>
      }

      <Grid container align="left" sx={{ borderBottom: 1, borderColor: 'grey.500', pb: 1 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mr: 0, mt: 1 }}>
            <b>Supported Documents</b>
          </Typography>
        </Grid>
      </Grid>

      
        <Grid container>
          <Grid item xs={12}>

          {RootRecord != null && RootRecord.prsGoogleDocName &&
            <Button
              sx={{ mr: 2, mt: 0.5, mb: 1 }}
              variant="contained"
              color="warning"
              size="small"
              disabled={MessageData.Loading}
              onClick={() => downloadFile(RootRecord.prsGoogleDocName, RootRecord.prsGoogleDocFileID)}
            >
              Payroll File: {RootRecord.prsGoogleDocName}
            </Button>
          }

            {RootRecord != null && RootRecord.prsGoogleDocName2 &&
            <Button
              sx={{ mr: 2, mt: 0.5, mb: 1 }}
              variant="contained"
              color="warning"
              size="small"
              disabled={MessageData.Loading}
              onClick={() => downloadFile(RootRecord.prsGoogleDocName2, RootRecord.prsGoogleDocFileID2)}
            >
              Payroll File: {RootRecord.prsGoogleDocName2}
            </Button>
            }
          </Grid>
        </Grid>
      


      <Grid container align="left" sx={{ borderBottom: 1, borderColor: 'grey.500', pb: 1 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mr: 0, mt: 1 }}>
            <b>Supported Emails</b>
          </Typography>
        </Grid>
      </Grid>

      {RootRecord != null &&
        <Grid container>
          <Grid item xs={12}>
            {RootRecord.prsSubmittedGoogleDocFileID &&
              <Button
                sx={{ mr: 2, mt: 0.5, mb: 1 }}
                variant="contained"
                color="warning"
                size="small"
                disabled={MessageData.Loading}
                onClick={() => downloadFile(RootRecord.prsSubmittedGoogleDocName, RootRecord.prsSubmittedGoogleDocFileID)}
              >
                Submission proof (Step #1): {RootRecord.prsSubmittedGoogleDocName}
              </Button>
            }

            {RootRecord.prsVerifierGoogleDocFileID &&
              <Button
                sx={{ mr: 2, mt: 0.5, mb: 1 }}
                variant="contained"
                color="warning"
                size="small"
                disabled={MessageData.Loading}
                onClick={() => downloadFile(RootRecord.prsVerifierGoogleDocName, RootRecord.prsVerifierGoogleDocFileID)}
              >
                Verification proof (Step #2): {RootRecord.prsVerifierGoogleDocName}
              </Button>
            }

            {RootRecord.prsVerifierGoogleDocFileID2 &&
              <Button
                sx={{ mr: 2, mt: 0.5, mb: 1 }}
                variant="contained"
                color="warning"
                size="small"
                disabled={MessageData.Loading}
                onClick={() => downloadFile(RootRecord.prsVerifierGoogleDocName2, RootRecord.prsVerifierGoogleDocFileID2)}
              >
                Verification proof (Step #3): {RootRecord.prsVerifierGoogleDocName2}
              </Button>
            }

            {RootRecord.prsFinalizedGoogleDocFileID &&
              <Button
                sx={{ mr: 0, mt: 0.5, mb: 1 }}
                variant="contained"
                color="warning"
                size="small"
                disabled={MessageData.Loading}
                onClick={() => downloadFile(RootRecord.prsFinalizedGoogleDocName, RootRecord.prsFinalizedGoogleDocFileID)}
              >
                Approval proof (Step #4): {RootRecord.prsFinalizedGoogleDocName}
              </Button>
            }

          </Grid>

        </Grid>
      }
    </Typography>
  );
}


